export const STANDARD_TOAST_POSITION_CLASS = '-translate-x-1/2 fixed top-[72px] left-1/2';

export const STANDARD_TOAST_CLASS =
  'w-fit rounded-[100px] border-none bg-[#2E2F33] px-6 py-4 font-semibold text-sm text-white shadow-none backdrop-blur-[20px]';

export const STANDARD_TOAST_TEXT_CLASS = 'font-semibold text-sm text-white leading-5 opacity-100';
